import { useMemo } from 'react';
import { createAuthenticatedApiClient } from '../../../shared/api/apiClient';
import { rpcCall } from '../../../shared/api/rpcClient';
import { useAuth } from '../../auth/context/AuthContext';
import type { ModelBinding, ModelBindingUpdateRequest } from '../../../types/backend';

// The model each non-agent prompt use runs on; a use with no row has no model (PS-UC-17).
export const createModelBindingService = (idToken: string) => {
  const client = createAuthenticatedApiClient(idToken);

  return {
    listModelBindings: async (): Promise<ModelBinding[]> =>
      rpcCall(client, 'modelbinding.ListModelBindings', {}),

    updateModelBinding: async (request: ModelBindingUpdateRequest): Promise<ModelBinding> =>
      rpcCall(client, 'modelbinding.UpdateModelBinding', request),
  };
};

export const useModelBindingService = () => {
  const { idToken } = useAuth();

  return useMemo(() => {
    if (!idToken) {
      throw new Error('useModelBindingService requires authentication');
    }

    return createModelBindingService(idToken);
  }, [idToken]);
};
